(function ($) {
  $(document).ready(function() {
    //parallax scroll
    $(window).on("load scroll", function() {
      if ($(window).width() > 768) {
        parallaxElement(-0.1)
      }
      else {
        parallaxElement(-0.1)
      }
    });
    if($('select').length){
      $('select').select2();   
    }
  });
  $(window).on('resize', function(){
    $(window).on("load scroll", function() {
      if ($(window).width() > 768) {
        parallaxElement(-0.1)
      }
      else {
        parallaxElement(-0.1)
      }
    });
  });
  
  function parallaxElement(number){
    var parallaxElement = $(".parallax_scroll"),
        parallaxQuantity = parallaxElement.length;
    window.requestAnimationFrame(function() {
      for (var i = 0; i < parallaxQuantity; i++) {
        var currentElement = parallaxElement.eq(i),
            windowTop = $(window).scrollTop(),
            elementTop = currentElement.offset().top,
            elementHeight = currentElement.height(),
            viewPortHeight = window.innerHeight * 0.5 - elementHeight * 0.5,
            scrolled = windowTop - elementTop + viewPortHeight;
        currentElement.css({
          transform: "translate3d(0," + scrolled * number + "px, 0)"
        });
      }
    });
  }
})(jQuery);